import { render, staticRenderFns } from "./TNC.vue?vue&type=template&id=56fdde45&scoped=true"
import script from "./TNC.vue?vue&type=script&lang=js"
export * from "./TNC.vue?vue&type=script&lang=js"
import style0 from "./_tnc.css?vue&type=style&index=0&id=56fdde45&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fdde45",
  null
  
)

export default component.exports